import { AuthProvider } from '@/hooks/useAuth';
import * as Sentry from '@sentry/react';
import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router';

import { API_URL } from '@/api/base/url';

import { App } from './app';

const environment = process.env.CLOUD_ENVIRONMENT;

if (environment) {
    Sentry.init({
        dsn: 'https://d1d14b2ae0e37d39e310968f05d0c784@o814635.ingest.us.sentry.io/4509248918978560',
        tracesSampleRate: 1.0,
        tracePropagationTargets: [API_URL],
        environment: environment,
        sendDefaultPii: true,
    });
}

const root = createRoot(document.getElementById('fm-root') as HTMLElement);
const queryClient = new QueryClient();

root.render(
    <Sentry.ErrorBoundary>
        <StrictMode>
            <BrowserRouter>
                <AuthProvider>
                    <QueryClientProvider client={queryClient}>
                        <App />
                    </QueryClientProvider>
                </AuthProvider>
            </BrowserRouter>
        </StrictMode>
    </Sentry.ErrorBoundary>,
);
